// @flow
import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
  Col,
  Popover,
  PopoverHeader,
  PopoverBody
} from "reactstrap";
import "./../../node_modules/react-select/dist/react-select.css";
import Select, { Creatable } from "react-select";
import { bindActionCreators } from "redux";
import * as actions from "../actions";
import { compose, checkForm, setIn } from "../common/utils";
import * as API from "../common/api";
import styled from "../common/styled";
import { s3Delete } from "../common/aws_lib";

const { Text, Image, View } = styled.plain;

const checks = [
  {
    related: ["categoryName"],
    check: s => s && s.length,
    errMsg: () => "Category Name Required"
  }
];

const checkFormData = checkForm(checks);

class CategoryForm extends React.Component {
  state = {
    errMsg: null,
    isSubmitting: false,
    formData: {
      categoryName: "",
      subcategories: []
    },
    popoverOpen: false
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.type !== this.props.type ||
      nextProps.categoryName !== this.props.categoryName
    ) {
      this.loadData(nextProps);
    }
  }

  loadData(props) {
    this.setState({
      formData: {
        categoryName: props.categoryName,
        subcategories: props.subcategories
      }
    });
  }

  toggleDelete = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  };

  onChangeField = (key, val) => {
    this.setState(setIn(["formData", key], val, this.state));
  };

  validateForm = fields => {
    const data = this.state.formData;
    const errMsgs = checkFormData(data, fields);
    const newErrMsgs =
      fields && fields.length > 0
        ? { ...this.state.errMsgs, ...errMsgs }
        : errMsgs;
    const hasError =
      Object.keys(newErrMsgs).filter(key => newErrMsgs[key]).length > 0;

    if (!fields && hasError) {
      const firstError = Object.keys(errMsgs)
        .map(key => errMsgs[key])
        .filter(x => !!x)[0];
      toast.error(firstError);
    }

    this.setState({ errMsgs: newErrMsgs });
    return !hasError;
  };

  onSubmit = () => {
    if (!this.validateForm()) return;

    const data = this.state.formData;

    return actions.wrapLoading(
      this.props,
      API.AddCategory(data.categoryName, data.subcategories).then(
        result => {
          toast.success("Successfully Updated");
          return this.props.onDone();
        },
        e => {
          const msg = e.message;
          toast.error(msg);
        }
      )
    );
  };

  onDelete = () => {
    API.DeleteCategory(this.props.categoryName).then(
      result => {
        toast.success("Successfully Deleted");
        return this.props.onDone();
      },
      e => {
        const msg = e.message;
        toast.error(msg);
      }
    );
  };

  render() {
    const subcategories =
      this.state.formData &&
      (this.state.formData.subcategories || []).map(item => ({
        label: item,
        value: item
      }));

    return (
      <Modal
        isOpen={this.props.visible}
        className="photoModal"
        onClosed={this.props.onClose}
        size="lg"
      >
        <ModalHeader>Manage Category</ModalHeader>
        <ModalBody>
          <Form className="photo-form">
            <div className="form-field">
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Category Name</Label>
                    <Input
                      type="text"
                      name="categoryName"
                      required
                      value={this.state.formData.categoryName}
                      onChange={e =>
                        this.onChangeField("categoryName", e.target.value)
                      }
                      disabled={this.props.type === "EDIT"}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Subcategories</Label>
                    <Creatable
                      multi
                      name="subcategories"
                      defaultValue={subcategories}
                      required
                      value={this.state.formData.subcategories}
                      onChange={e =>
                        this.onChangeField(
                          "subcategories",
                          e.map(item => item.value)
                        )
                      }
                      options={subcategories}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={this.props.onClose}>
            Cancel
          </Button>

          {this.props.type === "EDIT" ? (
            <span>
              <Button
                id="Popover1"
                color="danger"
                outline
                onClick={this.toggleDelete}
              >
                Delete
              </Button>
              <Popover
                placement="top"
                isOpen={this.state.popoverOpen}
                target="Popover1"
                toggle={this.toggleDelete}
              >
                <PopoverHeader>Are you sure you want to delete?</PopoverHeader>
                <PopoverBody>
                  <Button color="danger" outline onClick={this.onDelete}>
                    Confirm
                  </Button>
                </PopoverBody>
              </Popover>
            </span>
          ) : null}

          {this.props.type === "EDIT" ? (
            <Button color="primary" outline onClick={() => this.onSubmit()}>
              Update
            </Button>
          ) : (
            <Button color="primary" outline onClick={() => this.onSubmit()}>
              Add
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

CategoryForm.propTypes = {
  categoryName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired
};

export default compose(
  connect(
    state => ({}),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(CategoryForm);
